import script from "./Galaxy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Galaxy.vue?vue&type=script&lang=ts&setup=true"

import "./Galaxy.vue?vue&type=style&index=0&id=aa6c3e9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa6c3e9c"]])

export default __exports__